export const COOKIE_CONSENT_STORAGE_KEY = 'tryinterview.cookie-consent.v1';
export const COOKIE_CONSENT_UPDATED_EVENT = 'tryinterview:cookie-consent-updated';
export const COOKIE_CONSENT_ACCEPT_ALL = 'accept-all';
export const COOKIE_CONSENT_ESSENTIAL_ONLY = 'essential-only';

const VALID_COOKIE_CONSENT_VALUES = new Set([
  COOKIE_CONSENT_ACCEPT_ALL,
  COOKIE_CONSENT_ESSENTIAL_ONLY,
]);

export function getCookieConsentPreference() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const storedValue = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    return VALID_COOKIE_CONSENT_VALUES.has(storedValue) ? storedValue : null;
  } catch {
    return null;
  }
}

export function persistCookieConsentPreference(preference) {
  if (typeof window === 'undefined' || !VALID_COOKIE_CONSENT_VALUES.has(preference)) {
    return preference;
  }

  try {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, preference);
  } catch {
    // Ignore write failures and keep the preference for the current session.
  }

  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_UPDATED_EVENT, {
    detail: { preference },
  }));

  return preference;
}

export function canLoadAnalytics(preference) {
  return preference === COOKIE_CONSENT_ACCEPT_ALL;
}

export function getCookieConsentLabel(preference) {
  switch (preference) {
    case COOKIE_CONSENT_ACCEPT_ALL:
      return 'Essential and analytics cookies enabled';
    case COOKIE_CONSENT_ESSENTIAL_ONLY:
      return 'Essential cookies only';
    default:
      return 'No preference saved yet';
  }
}
